import {
  VuexModule, Module, Mutation, Action, getModule,
} from 'vuex-module-decorators';
import store from '@/store';

export interface INoticeState {
  subscribeParamsFilter: {} | null
}

@Module({ dynamic: true, store, name: 'notice' })
class Notice extends VuexModule implements INoticeState {
  public subscribeParamsFilter = null;

  @Mutation
  private SET_SUBSCRIBE_PARAMS(item: any) {
    this.subscribeParamsFilter = item;
  }

  @Action
  public SetSubscribeParams(item: any) {
    this.SET_SUBSCRIBE_PARAMS(item);
  }
}

export const NoticeModule = getModule(Notice);
